import { Component, inject } from '@angular/core';
import { SelectAvatarService } from '../select-avatar.service';

@Component({
  selector: 'app-select-avatar-image-preview',
  templateUrl: './select-avatar-image-preview.component.html',
  styleUrls: ['./select-avatar-image-preview.component.scss'],
  standalone: false
})
export class SelectAvatarImagePreviewComponent {
  private selectAvatarService = inject(SelectAvatarService);

  public get avatarPathUrls(): string[] {
    return this.selectAvatarService.avatarPartUrls;
  }
}
